import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {OrientationView} from '@fantasmagames/slot/src/modules/orientation/OrientationView';
import {OrientationEvents} from '@fantasmagames/slot/src/modules/orientation/OrientationEvents';

export class OrientationModule extends Module<OrientationView> {

	protected setupViews(): void {
		this.setView(Views.ORIENTATION_NOTIFICATION_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onViewEmitEvent(OrientationView.ORIENTATION_CHANGED_TO_PORTRAIT, OrientationEvents.ORIENTATION_CHANGED_TO_PORTRAIT);
		this.onViewEmitEvent(OrientationView.ORIENTATION_CHANGED_TO_LANDSCAPE, OrientationEvents.ORIENTATION_CHANGED_TO_LANDSCAPE);
	}

	protected setupStates(): void {
	}

	protected enterFirstState(): void {
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/orientation/OrientationModule.ts